import { cn } from '~/lib/utils'

/**
 * Déclencheur « chip » des filtres de page (maquettes Prévisions, Contrôle rupture, Logistique) :
 * texte de marque vert sur fond transparent. Les écrans ajoutent leur fond et leur survol via `cn`.
 */
export const FILTER_CHIP_TRIGGER =
  'h-9 w-auto gap-2.5 rounded-lg border-transparent bg-transparent px-2 font-brand text-[18px] font-semibold leading-[20px] text-[#4f6a47] shadow-none [&_svg]:text-[#4f6a47]'

/** Variante pleine (fond clair, survol plus foncé) des chips posés hors d'une barre de filtres. */
export const FILTER_CHIP_TRIGGER_FILLED = cn(
  FILTER_CHIP_TRIGGER,
  'shrink-0 bg-[#f9f8f1] hover:bg-[#f0ede2]',
)

export const filterBarTriggerClass = (open: boolean) =>
  cn(
    'text-primary-900 flex h-9 items-center gap-2 rounded-lg border border-black/6 bg-white px-3 text-sm',
    open && 'border-primary-600',
  )

export const filterBarChevronClass = (open: boolean) =>
  cn('text-sage-500 size-4 transition-transform', open && 'rotate-180')
